import React, { Component } from 'react';
import './Test.css';


class Test extends Component {
    constructor(props) {
        super(props)
        this.state = {
            body_class: ['apps-gotlocked-order', 'apps-gotlocked-testimonial']
        }
    }

    componentWillMount() {
        setTimeout(function() {
            if (document.body.classNameList) {
                document.body.classNameList.add(...this.state.body_class);
            } else {
                document.body.className = this.state.body_class.join(' ');
            }
            //document.getElementById('apps-gotlocked-menu').style.display = 'none';
        }.bind(this), 1);
    }

    componentWillUnmount() {
        document.body.className = '';
    }

    render() {
        return (
            <div>
                <section className="apps-gotlocked-testimonial-section section-padding" id="apps-gotlocked-testimonial">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="apps-gotlocked-section-heading white">
                                        <h2>TEstimonials</h2>
                                    </div>
                                    <div className="content-margin-top">
                                        <div className="apps-gotlocked-testimonial-slider-wraper clear-both">
                                            <div id="apps-gotlocked-commentor-slider1" className="wow fadeIn" itemScope itemType="http://schema.org/ImageGallery">
                                                <div className="apps-gotlocked-testimonial-content clear-both">
                                                    <div className="apps-gotlocked-testimonial-single clear-both">
                                                        <div className="apps-gotlocked-commentor-img-continer">
                                                            <figure className="apps-gotlocked-commentor-img" itemProp="associatedMedia" itemScope itemType="http://schema.org/ImageObject">
                                                                <img src="/img/commentor-img.png" alt="" />
                                                                <figcaption>
                                                                    <i className="zmdi zmdi-comment-outline zmdi-hc-fw"></i>
                                                                </figcaption>
                                                            </figure> 
                                                        </div>

                                                        <div className="apps-gotlocked-rating-and-bio clear-both">
                                                            <p>Such an easy to use service! I will never have to use Google again! You simply open a call and within 20 min the locksmith arrives at your door. The service was great too!</p>
                                                            <div className="apps-gotlocked-rating">
                                                                <ul>
                                                                    <li><a href=""><i className="zmdi zmdi-star zmdi-hc-fw"></i></a></li>
                                                                    <li><a href=""><i className="zmdi zmdi-star zmdi-hc-fw"></i></a></li>
                                                                    <li><a href=""><i className="zmdi zmdi-star zmdi-hc-fw"></i></a></li>
                                                                    <li><a href=""><i className="zmdi zmdi-star zmdi-hc-fw"></i></a></li>
                                                                    <li><a href=""><i className="zmdi zmdi-star-half zmdi-hc-fw"></i></a></li>
                                                                </ul>
                                                            </div>
                                                            <div className="apps-gotlocked-commentor-bio">
                                                                <h3>mr. gate  - <span></span></h3>
                                                            </div> 
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="apps-gotlocked-testimonial-content clear-both">
                                                    <div className="apps-gotlocked-testimonial-single clear-both">
                                                        <div className="apps-gotlocked-commentor-img-continer">
                                                            <figure className="apps-gotlocked-commentor-img" itemProp="associatedMedia" itemScope itemType="http://schema.org/ImageObject">
                                                                <img src="/img/commentor-img-2.png" alt="" />

                                                                <figcaption>
                                                                    <i className="zmdi zmdi-comment-outline zmdi-hc-fw"></i>
                                                                </figcaption>
                                                            </figure>
                                                        </div>

                                                        <div className="apps-gotlocked-rating-and-bio clear-both">
                                                            <p>No need to worry about locking myself out yet again. This is a must have app for me - quick and pain free, with great pricing! No need to call or do any research. The only downside is that I use it way too often!</p>
                                                            <div className="apps-gotlocked-rating">
                                                                <ul>
                                                                    <li><a href=""><i className="zmdi zmdi-star zmdi-hc-fw"></i></a></li>
                                                                    <li><a href=""><i className="zmdi zmdi-star zmdi-hc-fw"></i></a></li>
                                                                    <li><a href=""><i className="zmdi zmdi-star zmdi-hc-fw"></i></a></li>
                                                                    <li><a href=""><i className="zmdi zmdi-star zmdi-hc-fw"></i></a></li>
                                                                    <li><a href=""><i className="zmdi zmdi-star-half zmdi-hc-fw"></i></a></li>
                                                                </ul>
                                                            </div>

                                                            <div className="apps-gotlocked-commentor-bio">
                                                                <h3>jhon cena  - <span></span></h3>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="apps-gotlocked-testimonial-content clear-both">
                                                    <div className="apps-gotlocked-testimonial-single clear-both">
                                                        <div className="apps-gotlocked-commentor-img-continer">
                                                            <figure className="apps-gotlocked-commentor-img" itemProp="associatedMedia" itemScope itemType="http://schema.org/ImageObject">
                                                                <img src="/img/commentor-img-3.png" alt="" />

                                                                <figcaption>
                                                                    <i className="zmdi zmdi-comment-outline zmdi-hc-fw"></i>
                                                                </figcaption>
                                                            </figure> 
                                                        </div>

                                                        <div className="apps-gotlocked-rating-and-bio clear-both">
                                                            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in an voluptate velit esse cillum dolore eu fugiat nulla pariatur. </p>
                                                            <div className="apps-gotlocked-rating">
                                                                <ul>
                                                                    <li><a href=""><i className="zmdi zmdi-star zmdi-hc-fw"></i></a></li>
                                                                    <li><a href=""><i className="zmdi zmdi-star zmdi-hc-fw"></i></a></li>
                                                                    <li><a href=""><i className="zmdi zmdi-star zmdi-hc-fw"></i></a></li>
                                                                    <li><a href=""><i className="zmdi zmdi-star zmdi-hc-fw"></i></a></li>
                                                                    <li><a href=""><i className="zmdi zmdi-star-half zmdi-hc-fw"></i></a></li>
                                                                </ul>
                                                            </div> 
                                                            <div className="apps-gotlocked-commentor-bio">
                                                                <h3>STEVE JOBs  - <span>ui Designer</span></h3>
                                                            </div> 
                                                        </div> 
                                                    </div>
                                                </div>
                                            </div> 
                                            {/* <div className="customNavigation">
                                                <a className="prev"><i className="zmdi zmdi-long-arrow-left zmdi-hc-fw"></i></a>
                                                <a className="next"><i className="zmdi zmdi-long-arrow-right zmdi-hc-fw"></i></a>
                                            </div> */}
                                        </div>

                                        {/* <div id="apps-gotlocked-testimonial-thumb" className="text-center wow fadeIn" itemScope itemType="http://schema.org/ImageGallery">
                                            <div className="item">
                                                <figure itemProp="associatedMedia" itemScope itemType="http://schema.org/ImageObject">
                                                    <img src="/img/testimonial-thumb-1.png" alt="Apps GotLocked Commentor Thumb" />
                                                </figure>
                                            </div>
                                            <div className="item">
                                                <figure itemProp="associatedMedia" itemScope itemType="http://schema.org/ImageObject">
                                                    <img src="/img/testimonial-thumb-2.png" alt="Apps GotLocked Commentor Thumb" />
                                                </figure>
                                            </div>
                                            <div className="item">
                                                <figure itemProp="associatedMedia" itemScope itemType="http://schema.org/ImageObject">
                                                    <img src="/img/testimonial-thumb-3.png" alt="Apps GotLocked Commentor Thumb" />
                                                </figure>
                                            </div>
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                </section>
            </div>
        );
    }
}

export default Test;